import { useContext } from "react"
import { SignContext } from "../context/SignContext";

export const useSignContext = () => {
    return useContext(SignContext);
}